import React from "react";
import { Link } from "react-router-dom";
import { Zap, Truck, Clock, Tag, Phone, CheckCircle2, ShieldCheck, ArrowDown, Ban } from "lucide-react";
import { CallbackMini } from "@/components/forms/CallbackMini";
import { PHONE, PHONE_TEL } from "@/data/site";
import { track } from "@/lib/analytics";
import { OfferCountdown } from "@/components/OfferCountdown";

export const SpecialOffer = ({ compact = false, formMode = false }) => (
  <section className={`${compact ? "" : "max-w-6xl mx-auto px-4 sm:px-6"}`} data-testid="special-offer">
    <div className="rounded-3xl overflow-hidden text-white" style={{ backgroundColor: "var(--sc-emerald)" }}>
      <div className="p-6 sm:p-10">
        <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest bg-white/20 px-3 py-1.5 rounded-full">
          <Zap size={14} /> Offerta speciale · solo conferma ordine online
        </span>
        <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold leading-tight" style={{ fontFamily: "Outfit" }}>
          Prenota subito la tua SENIORCAR
        </h2>

        <div className="mt-5 flex flex-wrap items-end gap-3">
          <span className="text-4xl sm:text-5xl font-extrabold" style={{ fontFamily: "Outfit" }}>€5.490</span>
          <span className="text-white/85 text-lg mb-1">+ IVA + trasporto</span>
        </div>
        <p className="mt-2 text-white/80 text-sm">Prezzo riservato esclusivamente alla conferma dell'ordine online.</p>
        <OfferCountdown />

        <div className="mt-5 inline-flex items-start gap-2.5 rounded-2xl bg-white/15 border border-white/25 px-4 py-3" data-testid="offer-reassurance">
          <ShieldCheck size={20} className="mt-0.5 shrink-0" />
          <p className="text-sm text-white/95 leading-relaxed">
            <strong className="text-white">Nessun pagamento online.</strong> Prenoti e lasci i tuoi dati: sarà l'azienda a ricontattarti per perfezionare l'ordine con i metodi di pagamento tradizionali.
          </p>
        </div>

        <div className="mt-7 grid sm:grid-cols-2 gap-4">
          <div className="relative rounded-2xl bg-black/25 border border-white/15 p-5 opacity-70 cursor-not-allowed select-none" aria-disabled="true" data-testid="offer-option-ready">
            <span className="mb-3 inline-flex items-center gap-1 rounded-full bg-slate-900 text-white text-xs font-extrabold uppercase tracking-wider px-3 py-1" data-testid="offer-option-ready-soldout"><Ban size={14} /> Esaurito</span>
            <div className="flex items-center gap-2 font-bold text-lg text-white/70"><Truck size={20} /> Consegna rapida</div>
            <p className="mt-2 text-white/60 text-sm flex items-start gap-2 line-through"><Clock size={16} className="mt-0.5 shrink-0" /> Consegna in 8 giorni</p>
            <p className="mt-3 text-2xl font-extrabold text-white/60 line-through" style={{ fontFamily: "Outfit" }}>€5.990 <span className="text-sm font-semibold">+ IVA + trasporto</span></p>
            <p className="mt-2 text-sm font-semibold text-white">Non disponibile: scorte a magazzino esaurite.</p>
          </div>
          <div className="relative rounded-2xl bg-white text-slate-900 p-5 shadow-lg ring-4 ring-white/40" data-testid="offer-option-production">
            <span className="mb-3 inline-flex items-center gap-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-extrabold uppercase tracking-wider px-3 py-1" data-testid="offer-option-production-available"><CheckCircle2 size={14} /> Disponibile</span>
            <div className="flex items-center gap-2 font-bold text-lg" style={{ color: "var(--sc-emerald)" }}><Tag size={20} /> In produzione (3 mesi)</div>
            <p className="mt-2 text-slate-600 text-sm flex items-start gap-2"><CheckCircle2 size={16} className="mt-0.5 shrink-0 text-emerald-700" /> <span>Se accetti l'attesa di 3 mesi, <strong>sconto extra di €500</strong>.</span></p>
            <p className="mt-3 text-2xl font-extrabold text-slate-900" style={{ fontFamily: "Outfit" }}>€5.490 <span className="text-sm font-semibold text-slate-500">+ IVA + trasporto</span></p>
          </div>
        </div>

        <div className="mt-7 flex flex-col sm:flex-row gap-3">
          {formMode ? (
            <a href="#offer-form" onClick={() => track("offer_cta_click", { source: "offer_page" })}
              className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-full font-extrabold text-lg bg-white text-[var(--sc-emerald)] shadow-lg transition-transform hover:scale-[1.02]"
              data-testid="offer-book-cta">
              Compila il modulo e prenota <ArrowDown size={20} />
            </a>
          ) : (
            <Link to="/offerta" onClick={() => track("offer_cta_click", { source: compact ? "offer_page" : "banner" })}
              className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-full font-extrabold text-lg bg-white text-[var(--sc-emerald)] shadow-lg transition-transform hover:scale-[1.02]"
              data-testid="offer-book-cta">
              Prenota subito la tua SENIORCAR
            </Link>
          )}
          <a href={`tel:${PHONE_TEL}`} onClick={() => track("phone_click", { source: "special_offer" })}
            className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-full font-bold text-lg border-2 border-white/70 hover:bg-white/10" data-testid="offer-call-cta">
            <Phone size={20} /> {PHONE}
          </a>
        </div>
        <div className="mt-6 max-w-xl"><CallbackMini source={formMode ? "offer-page" : "offer-banner"} dark /></div>
        <p className="mt-4 text-xs text-white/70">Offerta valida solo per conferma ordine online. IVA e trasporto esclusi; eventuali agevolazioni (IVA agevolata/Legge 104) da verificare caso per caso.</p>
      </div>
    </div>
  </section>
);
